// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"9b25b1ce","473":"9f102431"}[chunkId] + ".chunk.css";
};